import { NgModule } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

@NgModule({
  providers: [InAppBrowser],
})
export class InAppBrowserModule {}
